import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {ApiClient} from '@forlabs/api-bridge';
import {DefaultDataServiceConfig, EntityCollectionServiceElementsFactory, HttpUrlGenerator} from '@ngrx/data';
import {Action, ScannedActionsSubject} from '@ngrx/store';
import {Observable} from 'rxjs';
import {EntityCollectionService, FollowMeDataService} from '../metadata';
import {WorkflowButton, WorkflowButtonInterface} from './workflow-buttons.models';


@Injectable()
export class WorkflowButtonCollectionService extends EntityCollectionService<WorkflowButtonInterface> {
  constructor(
    serviceElementsFactory: EntityCollectionServiceElementsFactory,
    @Inject(ScannedActionsSubject) scannedActions$: Observable<Action>,
  ) {
    super(WorkflowButton, serviceElementsFactory, scannedActions$);
  }
}

@Injectable()
export class WorkflowButtonDataService extends FollowMeDataService<WorkflowButtonInterface> {
  constructor(
    apiClient: ApiClient,
    http: HttpClient,
    httpUrlGenerator: HttpUrlGenerator,
    config?: DefaultDataServiceConfig,
  ) {
    super(WorkflowButton, apiClient, http, httpUrlGenerator, config);
  }
}
